import React from "react";

function BusIcon2() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      fill="none"
      viewBox="0 0 13 16"
    >
      <path
        fill="currentColor"
        d="M11.27 1.505A2.662 2.662 0 009.403.5h-6.57A2.602 2.602 0 00.958 1.512 3.24 3.24 0 00.118 3.5v9a.75.75 0 00.75.75h1.5l-1.5 2.25h1.74l.51-.75h6l.51.75h1.74l-1.5-2.25h1.5a.75.75 0 00.75-.75v-9a3.112 3.112 0 00-.848-1.995zM2.833 2h6.54c.3.073.565.248.75.495.068.08.13.166.187.255h-8.4c.054-.093.117-.181.188-.263.177-.247.438-.42.735-.487zM1.618 5v-.75h9V6.5h-9V5zm9 6.75h-9V8h9v3.75z"
      ></path>
    </svg>
  );
}

export default BusIcon2;
